export type UpdateComponentProjectsResponse = {};
